import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../css/pdf.css';
import { GoogleMap, Marker, LoadScript, Polyline, Circle } from '@react-google-maps/api';
import { fetchGoogleMapDetails } from '../../features/Vessels/VesselSlice';

const MapContainer = () => {
    const google = window.google;
    const { statementDocument } = useSelector((state) => state.voyage);
    const dispatch = useDispatch()
    const [mapDetails, setMapDetails] = useState([])
    const [path, setPath] = useState([]);

    const [mapCenter, setMapCenter] = useState({ lat: 27.964157, lng: -82.452606 });

    const [zoomLevel, setZoomLevel] = useState(3);
    const mapRef = useRef(null);

    const handleZoomChanged = () => {
        // Get the current zoom level from the map
        if (mapRef.current) {
            const newZoomLevel = mapRef.current.getZoom();

            // Update the state or a variable with the new zoom level
            setZoomLevel(newZoomLevel);
        }
    };




    const [mapImage, setMapImage] = useState(null);

    useEffect(() => {
        setZoomLevel(3);
        if (!statementDocument) return;

        dispatch(fetchGoogleMapDetails({
            casper_id: statementDocument?.report_number,
            imo_number: statementDocument?.vessel_particulars?.imo_number,
        })).then((result) => {
            if (result.payload) {
                const coordinates = result.payload.coordinates.map(coord => ({
                    lat: parseFloat(coord.lat),
                    lng: parseFloat(coord.lng),
                }));
                setMapDetails(result.payload.coordinates);
                setPath(coordinates);

                if (coordinates.length > 0) {
                    const midPoint = coordinates.reduce(
                        (acc, cur) => {
                            acc.lat += cur.lat;
                            acc.lng += cur.lng;
                            return acc;
                        },
                        { lat: 0, lng: 0 }
                    );
                    setMapCenter({
                        lat: midPoint.lat / coordinates.length,
                        lng: midPoint.lng / coordinates.length,
                    });
                }
            } else {
                setMapDetails([]);
                setPath([]);
            }
        });
    }, [statementDocument, dispatch]);

    const getStaticMapUrl = () => {

        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

        if (path.length === 0) {
            // Default map when no path is available
            const defaultLat = mapCenter.lat;
            const defaultLng = mapCenter.lng;
            const defaultZoom = 3; // You can adjust the zoom level
            // const defaultMarker = `markers=color:red|label:A|${defaultLat},${defaultLng}`;
            return `https://maps.googleapis.com/maps/api/staticmap?size=800x400&zoom=${defaultZoom}&key=${apiKey}`;
        }


        const pathCoordinates = path.map(coord => `${coord.lat},${coord.lng}`).join('|');
        // const markers = `markers=color:black|${path[0].lat},${path[0].lng}|${path[path.length - 1].lat},${path[path.length - 1].lng}`;
        const startMarker = `markers=color:blue|label:S|${path[0].lat},${path[0].lng}`;
        // End port: Normal black marker
        const endMarker = `markers=color:black|label:E|${path[path.length - 1].lat},${path[path.length - 1].lng}`;
        // return `https://maps.googleapis.com/maps/api/staticmap?size=800x400&path=${pathCoordinates}&${markers}&key=${apiKey}`;
        return `https://maps.googleapis.com/maps/api/staticmap?size=800x400&path=${pathCoordinates}&${startMarker}&${endMarker}&key=${apiKey}`;
    };

    useEffect(() => {
        // if (path.length === 0) return;

        const staticMapUrl = getStaticMapUrl();
        fetch(staticMapUrl)
            .then((response) => response.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.onload = () => setMapImage(reader.result);
                reader.readAsDataURL(blob);
            });
    }, [path]);

    return (
        <div style={{ height: "100%", boxShadow: 'none' }}>
            {mapImage ? (
                <img src={mapImage} alt="Static Map" style={{ width: "100%", borderRadius: "10px", height: "100%",  objectFit: "cover",
                    clipPath: "inset(0px 0px 5px 0px)"  }} />
            ) : (
                <p>Loading map...</p>
            )}
        </div>
    );
}

export default MapContainer;
